import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home-page',
      component: () => import('../pages/home/homepage.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/home/login.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../pages/home/register/register.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/review',
      name: 'review',
      component: () => import('../pages/home/review/review.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/brand-review',
      name: 'brand-review',
      component: () => import('../pages/home/brand-review/brand-review.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/vilocal-img-review',
      name: 'vilocal-img-review',
      component: () => import('../pages/vilocal/api-img-review.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/forget',
      name: 'forget',
      component: () => import('../pages/forget/index.vue'),
      meta: {
        title: ''
      }
    },
    {
      path: '/menu/:key?',
      name: 'menu',
      component: () => import('../pages/components/menu-index')
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js